// extracted by mini-css-extract-plugin
export default {"container":"CardModo_container__yyFZD","title":"CardModo_title__AbIP1"};